module.exports = __webpack_public_path__ + "img/detBannerBlue.3ac57220.jpg";